import {MathUtils} from '@astek/utils';
import {DateTime} from 'luxon';

export module SharedUtils {

  export function secondsToString(time: number, minutesOnTwoDigits: boolean = false): string {
    const minutes = Math.floor(Math.abs(time) / 60);
    const seconds = Math.floor(Math.abs(time) % 60);
    let representation = '';
    if (time < 0) {
      representation += '-';
    }
    if (minutesOnTwoDigits && minutes < 10) {
      representation += '0';
    }
    representation += MathUtils.toFixedStep(minutes, 1);
    representation += ':';
    if (seconds < 10) {
      representation += '0';
    }
    representation += MathUtils.toFixedStep(seconds, 1);
    return representation;
  }

  export function diffToNowInYears(date: DateTime): number {
    return Math.floor(-date.diffNow('years').years);
  }

  export function forceDownload(blob: Blob, filename: string): void {
    const link: HTMLAnchorElement = document.createElement('a');
    const objectUrl: string = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(objectUrl);
    link.remove();
  }

}
